__webpack_require__.p = "/shared-mailboxes-cleanup/referrals-hub/";